import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "classroom" }
const _hoisted_2 = { class: "select" }
const _hoisted_3 = { class: "check_box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "result flex" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("操作")
const _hoisted_7 = {
  key: 0,
  class: "class_list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "infos" }
const _hoisted_10 = ["checked", "onClick"]
const _hoisted_11 = { class: "cls_name" }
const _hoisted_12 = { class: "operate" }
const _hoisted_13 = { class: "sheet_header" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_15 = { class: "sheet_content" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_top = _resolveComponent("head-top")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_head_top, {
      title: "教室管控",
      isBackHome: false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_dropdown_menu, { "active-color": "#1989fa" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_dropdown_item, {
            onChange: $options.campusChange,
            modelValue: $data.campusValues,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.campusValues) = $event)),
            options: $data.campusOptions
          }, null, 8, ["onChange", "modelValue", "options"]),
          _createVNode(_component_van_dropdown_item, {
            onChange: $options.buildingChange,
            modelValue: $data.buildingValues,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.buildingValues) = $event)),
            options: $data.buildingOptions
          }, null, 8, ["onChange", "modelValue", "options"]),
          _createVNode(_component_van_dropdown_item, {
            onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.filter($data.terminalType))),
            modelValue: $data.clsValues,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.clsValues) = $event)),
            options: $data.clsOptions
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_van_dropdown_item, {
            onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.filter($data.terminalType))),
            modelValue: $data.clsTypeValues,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.clsTypeValues) = $event)),
            options: $data.clsTypeOptions
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.terminalTypeList, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            class: _normalizeClass($data.terminalType === index ? 'active' : ''),
            onClick: ($event: any) => ($options.filter(index))
          }, _toDisplayString(item), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["classroom_list", $data.show ? 'short' : ''])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, "全部终端共有 " + _toDisplayString($data.classList.length) + " 台", 1),
        _createVNode(_component_van_button, {
          type: "primary",
          size: "mini",
          disabled: !$data.IsCtrlOP,
          onClick: $options.operate
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      ($data.classList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "class_item",
                key: index,
                onClick: ($event: any) => ($options.linkTo(item))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  ($data.isShowAllSelect)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "checkbox",
                        type: "checkbox",
                        checked: item.checked,
                        onClick: _withModifiers(($event: any) => (item.checked = !item.checked), ["stop"])
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["state", 
                item.Terminal.State === 3
                  ? 'using'
                  : item.Terminal.State === 0 ||
                    item.Terminal.State === 1 ||
                    item.Terminal.State === 2
                  ? 'free'
                  : item.Terminal.State === -1
                  ? 'offline'
                  : ''
              ])
                  }, _toDisplayString(item.Terminal.State === 3
                  ? "使用中"
                  : item.Terminal.State === 0 ||
                    item.Terminal.State === 1 ||
                    item.Terminal.State === 2
                  ? "空闲"
                  : item.Terminal.State === -1
                  ? "离线"
                  : ""), 3),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["iconfont icon-terminal", {
                  offline: !item.Terminal || item.Terminal.State === -1,
                  using: item.Terminal && item.Terminal.State === 3,
                  ShuttingDown: item.Terminal && item.Terminal.State === 1,
                  Opening: item.Terminal && item.Terminal.State === 2,
                  free: item.Terminal && item.Terminal.State === 0,
                }])
                    }, null, 2)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["iconfont icon-wulianwang", {
                  offline: item.IOTState === 0,
                  free: item.IOTState === 1,
                }])
                    }, null, 2)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["iconfont icon-lubo", {
                  offline: !item.RB || item.RB.REC === -2,
                  rec: item.RB && item.RB.REC === 1,
                  live: item.RB && item.RB.Live,
                  free: item.RB && item.RB.REC === 0,
                }])
                    }, null, 2)
                  ])
                ])
              ], 8, _hoisted_8))
            }), 128))
          ]))
        : ($data.terminalType === 0 && $data.classList.length === 0)
          ? (_openBlock(), _createBlock(_component_van_loading, {
              key: 1,
              type: "spinner",
              color: "#1989fa"
            }))
          : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_van_action_sheet, {
      show: $data.show,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (($data.show) = $event)),
      overlay: false,
      round: false,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_checkbox, {
            modelValue: $data.allSelect,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.allSelect) = $event)),
            shape: "square"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("span", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.cancel && $options.cancel(...args)))
          }, "取消")
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Actions, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index,
              onClick: ($event: any) => ($options.Control(item))
            }, _toDisplayString(item.name), 9, _hoisted_16))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}